class sortingCollection extends HTMLElement {
    constructor() {
        super();
        this.sortedButtons = Array.from(this.querySelectorAll('[data-trigger-sort-button]'));
        this.sectionId = this.dataset.sectionId;
        this.setListeners();
    }

    setListeners () {
        this.sortedButtons.forEach((sortedButton) => {
            sortedButton.addEventListener('click', (e) => {
                const url = `${window.location.pathname}?sort_by=${sortedButton.value}`;
                sessionStorage.setItem('bimotal_sort_by', sortedButton.value);
                window.history.pushState({ sort_by: sortedButton.value }, 'Title', url);
                this.setActiveButton(e.target);
            })
        })
        window.navigation.addEventListener('navigate', (e) => {
            setTimeout(() => {
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                /*const url = `${window.location.pathname}?sort_by=${sort_by}`;*/
                console.log('urlParams: ', urlParams.get('sort_by'))

              /*  console.log('window.location: ', window.location)
                console.log('window.history: ', window.history)
                console.log('window.history.sort_by: ', window.history.state.sort_by)*/
                this.renderPage(`${window.location.pathname}?sort_by=${urlParams.get('sort_by')}`);
            },1000)
        })
    }

    renderPage (url) {
        fetch(`${url}&section_id=${this.sectionId}`)
            .then((res) => res.text())
            .then((res) => {
                const htmlSorted = new DOMParser().parseFromString(res, "text/html")

                const productsGridCurrent = document.getElementById(`products-grid-${this.sectionId}`);
                const productsGridSorted = htmlSorted.getElementById(`products-grid-${this.sectionId}`);
                productsGridCurrent.innerHTML = productsGridSorted.innerHTML;
            });
    }

    setActiveButton(buttonToActivate) {
        const sortedButtons = Array.from(this.querySelectorAll('.elevate__sorting-item.active'));
        if (sortedButtons.length) {
            sortedButtons.forEach((sortedButton) => {
                sortedButton.classList.remove('active');
                sortedButton.removeAttribute('disabled');
            })
        }
        buttonToActivate.classList.add('active');
        buttonToActivate.setAttribute('disabled', '');
    }
}
document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get('sorting-collection')) {
        customElements.define('sorting-collection', sortingCollection);
    }
})

